/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as LoginRouteImport } from './routes/login'
import { Route as AdminRouteImport } from './routes/admin'
import { Route as IndexRouteImport } from './routes/index'
import { Route as AdminIndexRouteImport } from './routes/admin/index'
import { Route as AdminStockRouteImport } from './routes/admin/stock'
import { Route as AdminStaffRouteImport } from './routes/admin/staff'
import { Route as AdminReportsRouteImport } from './routes/admin/reports'
import { Route as AdminExpensesRouteImport } from './routes/admin/expenses'
import { Route as AdminDashboardRouteImport } from './routes/admin/dashboard'
import { Route as AdminCounterRouteImport } from './routes/admin/counter'

const LoginRoute = LoginRouteImport.update({
  id: '/login',
  path: '/login',
  getParentRoute: () => rootRouteImport,
} as any)
const AdminRoute = AdminRouteImport.update({
  id: '/admin',
  path: '/admin',
  getParentRoute: () => rootRouteImport,
} as any)
const IndexRoute = IndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => rootRouteImport,
} as any)
const AdminIndexRoute = AdminIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AdminRoute,
} as any)
const AdminStockRoute = AdminStockRouteImport.update({
  id: '/stock',
  path: '/stock',
  getParentRoute: () => AdminRoute,
} as any)
const AdminStaffRoute = AdminStaffRouteImport.update({
  id: '/staff',
  path: '/staff',
  getParentRoute: () => AdminRoute,
} as any)
const AdminReportsRoute = AdminReportsRouteImport.update({
  id: '/reports',
  path: '/reports',
  getParentRoute: () => AdminRoute,
} as any)
const AdminExpensesRoute = AdminExpensesRouteImport.update({
  id: '/expenses',
  path: '/expenses',
  getParentRoute: () => AdminRoute,
} as any)
const AdminDashboardRoute = AdminDashboardRouteImport.update({
  id: '/dashboard',
  path: '/dashboard',
  getParentRoute: () => AdminRoute,
} as any)
const AdminCounterRoute = AdminCounterRouteImport.update({
  id: '/counter',
  path: '/counter',
  getParentRoute: () => AdminRoute,
} as any)

export interface FileRoutesByFullPath {
  '/': typeof IndexRoute
  '/admin': typeof AdminRouteWithChildren
  '/login': typeof LoginRoute
  '/admin/counter': typeof AdminCounterRoute
  '/admin/dashboard': typeof AdminDashboardRoute
  '/admin/expenses': typeof AdminExpensesRoute
  '/admin/reports': typeof AdminReportsRoute
  '/admin/staff': typeof AdminStaffRoute
  '/admin/stock': typeof AdminStockRoute
  '/admin/': typeof AdminIndexRoute
}
export interface FileRoutesByTo {
  '/': typeof IndexRoute
  '/login': typeof LoginRoute
  '/admin/counter': typeof AdminCounterRoute
  '/admin/dashboard': typeof AdminDashboardRoute
  '/admin/expenses': typeof AdminExpensesRoute
  '/admin/reports': typeof AdminReportsRoute
  '/admin/staff': typeof AdminStaffRoute
  '/admin/stock': typeof AdminStockRoute
  '/admin': typeof AdminIndexRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/': typeof IndexRoute
  '/admin': typeof AdminRouteWithChildren
  '/login': typeof LoginRoute
  '/admin/counter': typeof AdminCounterRoute
  '/admin/dashboard': typeof AdminDashboardRoute
  '/admin/expenses': typeof AdminExpensesRoute
  '/admin/reports': typeof AdminReportsRoute
  '/admin/staff': typeof AdminStaffRoute
  '/admin/stock': typeof AdminStockRoute
  '/admin/': typeof AdminIndexRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/admin'
    | '/login'
    | '/admin/counter'
    | '/admin/dashboard'
    | '/admin/expenses'
    | '/admin/reports'
    | '/admin/staff'
    | '/admin/stock'
    | '/admin/'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/'
    | '/login'
    | '/admin/counter'
    | '/admin/dashboard'
    | '/admin/expenses'
    | '/admin/reports'
    | '/admin/staff'
    | '/admin/stock'
    | '/admin'
  id:
    | '__root__'
    | '/'
    | '/admin'
    | '/login'
    | '/admin/counter'
    | '/admin/dashboard'
    | '/admin/expenses'
    | '/admin/reports'
    | '/admin/staff'
    | '/admin/stock'
    | '/admin/'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  IndexRoute: typeof IndexRoute
  AdminRoute: typeof AdminRouteWithChildren
  LoginRoute: typeof LoginRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/login': {
      id: '/login'
      path: '/login'
      fullPath: '/login'
      preLoaderRoute: typeof LoginRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/admin': {
      id: '/admin'
      path: '/admin'
      fullPath: '/admin'
      preLoaderRoute: typeof AdminRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/': {
      id: '/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof IndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/admin/': {
      id: '/admin/'
      path: '/'
      fullPath: '/admin/'
      preLoaderRoute: typeof AdminIndexRouteImport
      parentRoute: typeof AdminRoute
    }
    '/admin/stock': {
      id: '/admin/stock'
      path: '/stock'
      fullPath: '/admin/stock'
      preLoaderRoute: typeof AdminStockRouteImport
      parentRoute: typeof AdminRoute
    }
    '/admin/staff': {
      id: '/admin/staff'
      path: '/staff'
      fullPath: '/admin/staff'
      preLoaderRoute: typeof AdminStaffRouteImport
      parentRoute: typeof AdminRoute
    }
    '/admin/reports': {
      id: '/admin/reports'
      path: '/reports'
      fullPath: '/admin/reports'
      preLoaderRoute: typeof AdminReportsRouteImport
      parentRoute: typeof AdminRoute
    }
    '/admin/expenses': {
      id: '/admin/expenses'
      path: '/expenses'
      fullPath: '/admin/expenses'
      preLoaderRoute: typeof AdminExpensesRouteImport
      parentRoute: typeof AdminRoute
    }
    '/admin/dashboard': {
      id: '/admin/dashboard'
      path: '/dashboard'
      fullPath: '/admin/dashboard'
      preLoaderRoute: typeof AdminDashboardRouteImport
      parentRoute: typeof AdminRoute
    }
    '/admin/counter': {
      id: '/admin/counter'
      path: '/counter'
      fullPath: '/admin/counter'
      preLoaderRoute: typeof AdminCounterRouteImport
      parentRoute: typeof AdminRoute
    }
  }
}

interface AdminRouteChildren {
  AdminCounterRoute: typeof AdminCounterRoute
  AdminDashboardRoute: typeof AdminDashboardRoute
  AdminExpensesRoute: typeof AdminExpensesRoute
  AdminReportsRoute: typeof AdminReportsRoute
  AdminStaffRoute: typeof AdminStaffRoute
  AdminStockRoute: typeof AdminStockRoute
  AdminIndexRoute: typeof AdminIndexRoute
}

const AdminRouteChildren: AdminRouteChildren = {
  AdminCounterRoute: AdminCounterRoute,
  AdminDashboardRoute: AdminDashboardRoute,
  AdminExpensesRoute: AdminExpensesRoute,
  AdminReportsRoute: AdminReportsRoute,
  AdminStaffRoute: AdminStaffRoute,
  AdminStockRoute: AdminStockRoute,
  AdminIndexRoute: AdminIndexRoute,
}

const AdminRouteWithChildren = AdminRoute._addFileChildren(AdminRouteChildren)

const rootRouteChildren: RootRouteChildren = {
  IndexRoute: IndexRoute,
  AdminRoute: AdminRouteWithChildren,
  LoginRoute: LoginRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
